import React from "react";
import { AdminAuthProvider } from "./contexts/AdminAuthContext";
import Routes from "./Routes";

function App() {
  return (
    <AdminAuthProvider>
      <Routes />
    </AdminAuthProvider>
  );
}

export default App;